import React, { useEffect, useState } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function LifeAtSS() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Animation controls
  const headingControls = useAnimation();
  const contentControls = useAnimation();

  // Intersection observer
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  useEffect(() => {
    const runSequence = async () => {
      if (inView && !isMobile) {
        // Step 1: Animate heading
        await headingControls.start({
          y: 0,
          opacity: 1,
          transition: { duration: 0.8, ease: "easeOut" },
        });

        // Step 2: Animate content
        await contentControls.start({
          y: 0,
          opacity: 1,
          transition: { duration: 0.8, ease: "easeOut" },
        });
      }
    };

    runSequence();
  }, [inView, isMobile, headingControls, contentControls]);

  return (
    <div className="container-fluid px-0 pb-4" ref={ref}>
      <div className="col-12 p-4 mx-md-5">
        {isMobile ? (
          <h2 className="about-heading">#LifeatSprigStack</h2>
        ) : (
          <motion.h2
            className="about-heading"
            initial={{ y: -50, opacity: 0 }}
            animate={headingControls}
          >
            #LifeatSprigStack
          </motion.h2>
        )}
      </div>

      {isMobile ? (
        <Swiper
          slidesPerView={2}
          autoHeight={true}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 0, disableOnInteraction: false }}
          speed={5000}
          modules={[Autoplay]}
          className="LifeAtSprigStackSwiper"
        >
          {Array.from({ length: 29 }).map((_, i) => (
            <SwiperSlide key={i + "LifeAtSprigStack"}>
              {i + 1 === 4 || i + 1 === 6 || i + 1 === 12 ? (
                <video
                  src={`/images/AboutUs/about_us_carousel/${i + 1}.mp4`}
                  autoPlay
                  muted
                  loop
                  playsInline
                  webkit-playsinline="true"
                  className={`life-at-sprigstack-slide-img ${
                    i % 2 === 0 ? "horizontals" : "verticals"
                  } img-fluid`}
                />
              ) : (
                <LazyLoadImage
                  effect="blur"
                  src={`/images/AboutUs/about_us_carousel/${i + 1}.png`}
                  alt={`NewLifeAtSprigStack ${i + 1}`}
                  className={`life-at-sprigstack-slide-img ${
                    i % 2 === 0 ? "horizontals" : "verticals"
                  } img-fluid`}
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <motion.div initial={{ y: 50, opacity: 0 }} animate={contentControls}>
          <Swiper
            slidesPerView={3}
            autoHeight={true}
            spaceBetween={20}
            loop={true}
            autoplay={{ delay: 0, disableOnInteraction: false }}
            speed={5000}
            modules={[Autoplay]}
            className="LifeAtSprigStackSwiper"
          >
            {Array.from({ length: 28 }).map((_, i) => (
              <SwiperSlide key={i + "LifeAtSprigStack"}>
                {i + 1 === 4 || i + 1 === 6 || i + 1 === 12 ? (
                  <video
                    src={`/images/AboutUs/about_us_carousel/${i + 1}.mp4`}
                    autoPlay
                    muted
                    loop
                    className={`life-at-sprigstack-slide-img ${
                      i % 2 === 0 ? "horizontals" : "verticals"
                    } img-fluid`}
                  />
                ) : (
                  <img
                    src={`/images/AboutUs/about_us_carousel/${i + 1}.png`}
                    alt={`NewLifeAtSprigStack ${i + 1}`}
                    className={`life-at-sprigstack-slide-img ${
                      i % 2 === 0 ? "horizontals" : "verticals"
                    } img-fluid`}
                  />
                )}
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      )}
    </div>
  );
}
